import React, { Component } from 'react';
import horn from './sounds/alarm-clock.mp3';
import alarmLoud from './sounds/industrial-alarm.mp3';
import alert from './sounds/alert.mp3';
import bip1 from './sounds/notification1.mp3';
import bip2 from './sounds/notification2.mp3';
import alarm from './sounds/notification3.mp3';

export const Sounds = {
  horn,
  alarm,
  alert,
  bip1,
  bip2,
  alarmLoud,
};

export class Sound extends Component {
  render() {
    const { file, play, loop = false } = this.props;
    this.myRef = React.createRef();

    return !play ? '' : (
      <audio ref={this.myRef} src={file} autoPlay loop={loop}/>
    );
  }
}

export const playAudio = (file = Sounds.alert) => {
  const audio = new Audio(file);
  audio.play();
};
